import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ConfigProvider } from 'antd';
import enUS from 'antd/locale/en_US';
import App from './App';
import { store } from './store';
import '@/styles/global.scss';
import './i18n';
import 'antd/dist/reset.css';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider 
        locale={enUS}
        theme={{
          token: {
            colorPrimary: '#0D323E',  // 主题色
            borderRadius: 6,          // 圆角
            colorBgContainer: '#ffffff', // 背景色
            // 其他主题变量...
          },
        }}
      >
        <App />
      </ConfigProvider>
    </Provider>
  // </React.StrictMode>
); 